import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["Button", "useContentContainer", "onInsertComplete", "resetSelectedType", "allowSenderMeetingLink", "onInsertContent"];
import { useCallback, useState, useMemo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { RTEToolbarButton } from '../../components/StyledTextToolbarButton';
import { TextToolbarIcon } from 'rich-text-lib/components/editor/TextToolbarIcon';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import useDebouncedEditorStateContext from '../../contexts/useDebouncedEditorStateContext';
import { Popover } from 'foundations-components/transitional/components/Popover';
import { buildMeetingTr } from '../../utils/documentUtils';
import MeetingsPopover from './MeetingsPopover';
import { MeetingsIcon } from 'foundations-assets/icons/components/MeetingsIcon';
import { jsx as _jsx } from "react/jsx-runtime";
const MeetingsButton = ({
  onClick
}) => /*#__PURE__*/_jsx(Tooltip, {
  title: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "hubspot-prosemirror.tooltips.insertMeeting"
  }),
  children: /*#__PURE__*/_jsx(RTEToolbarButton, {
    "data-test-id": "meetings",
    onClick: onClick,
    selected: false,
    children: /*#__PURE__*/_jsx(TextToolbarIcon, {
      icon: MeetingsIcon
    })
  })
});
export default function InsertMeetings(_ref) {
  let {
      Button = MeetingsButton,
      useContentContainer,
      onInsertComplete = () => {},
      resetSelectedType = () => {},
      allowSenderMeetingLink,
      onInsertContent = () => {}
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    editorState,
    setEditorState
  } = useDebouncedEditorStateContext();
  const [open, setOpen] = useState(false);
  const insertMeeting = useCallback(({
    meetingURL,
    meetingName
  }) => {
    const tr = buildMeetingTr({
      meetingURL,
      meetingName,
      editorState
    });
    const newState = editorState.apply(tr);
    setEditorState(newState);
    onInsertComplete();
    onInsertContent();
  }, [editorState, setEditorState, onInsertComplete, onInsertContent]);
  const handleClose = useCallback(() => {
    setOpen(false);
  }, [setOpen]);
  const onOpenChange = useCallback(e => {
    setOpen(e.target.value);
  }, [setOpen]);
  const MeetingsPopoverContainer = useMemo(() => {
    if (useContentContainer) {
      return /*#__PURE__*/_jsx(MeetingsPopover, Object.assign({}, props, {
        onChange: insertMeeting,
        onClose: resetSelectedType,
        allowSenderMeetingLink: allowSenderMeetingLink,
        isNew: true
      }));
    }
    return /*#__PURE__*/_jsx(Popover, {
      open: open,
      onOpenChange: onOpenChange,
      content: /*#__PURE__*/_jsx(MeetingsPopover, Object.assign({}, props, {
        onChange: insertMeeting,
        onClose: handleClose,
        isNew: true,
        allowSenderMeetingLink: allowSenderMeetingLink
      })),
      children: /*#__PURE__*/_jsx(Button, {
        onClick: () => {
          setOpen(!open);
        }
      })
    });
  }, [Button, handleClose, insertMeeting, onOpenChange, open, props, resetSelectedType, useContentContainer, allowSenderMeetingLink]);
  return MeetingsPopoverContainer;
}